export default __webpack_public_path__ + "static/media/Detect-Security-monitoring.6e8535f8.svg";